import { Badge, Button, Modal } from '../../../components/UI'

const formatPrice = (value) => new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  maximumFractionDigits: 0
}).format(Number(value || 0))

export default function ProductViewModal({
  isOpen,
  product,
  onClose
}) {
  if (!product) return null

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      title="Detalle del producto"
      footer={
        <Button variant="secondary" onClick={onClose}>
          Cerrar
        </Button>
      }
    >
      <div className="space-y-6">
        <section className="grid grid-cols-1 gap-4 md:grid-cols-[160px_1fr]">
          <div className="h-40 overflow-hidden rounded-xl border border-gray-200 bg-gray-100">
            {product.videos?.[0]?.thumbnailUrl ? (
              <img
                src={product.videos[0].thumbnailUrl}
                alt={product.name}
                loading="lazy"
                className="h-full w-full object-cover"
              />
            ) : (
              <div className="flex h-full items-center justify-center text-sm text-gray-400">
                Sin miniatura
              </div>
            )}
          </div>

          <div className="space-y-3">
            <div>
              <div className="text-xl font-semibold text-gray-900">{product.name}</div>
              <div className="mt-1 text-sm text-gray-500">{product.slug}</div>
            </div>

            <div className="flex flex-wrap gap-2">
              <Badge variant={product.isActive ? 'success' : 'warning'}>
                {product.isActive ? 'Activo' : 'Inactivo'}
              </Badge>
              {product.category?.name && (
                <Badge variant="secondary">{product.category.name}</Badge>
              )}
              <Badge variant="secondary">{product.videos?.length || 0} videos</Badge>
            </div>

            <div className="text-2xl font-semibold text-slate-900">
              {formatPrice(product.price)}
            </div>

            <div className="grid grid-cols-1 gap-3 rounded-xl border border-gray-200 bg-gray-50 p-4 text-sm text-gray-700">
              <div>
                <div className="font-semibold text-gray-900">Descripcion</div>
                <div>{product.description || 'Sin descripcion registrada.'}</div>
              </div>
              <div>
                <div className="font-semibold text-gray-900">Presentacion</div>
                <div>{product.presentation || 'Sin presentacion registrada.'}</div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="mb-3 text-sm font-semibold text-gray-900">Videos asociados</div>
          <div className="space-y-3">
            {(product.videos || []).map((video) => (
              <div key={video.id} className="rounded-xl border border-gray-200 p-3">
                <div className="font-medium text-gray-900">{video.title}</div>
                <div className="text-sm text-gray-500">{video.sourceType}</div>
                <div className="break-all text-xs text-gray-400">{video.videoUrl}</div>
              </div>
            ))}
            {!product.videos?.length && (
              <div className="rounded-xl border border-dashed border-gray-300 p-4 text-sm text-gray-500">
                Este producto aun no tiene videos registrados.
              </div>
            )}
          </div>
        </section>
      </div>
    </Modal>
  )
}
